export const MAP_ACCESS_TOKEN = 'pk.eyJ1IjoiamFtZXMtZW1zIiwiYSI6ImNqbDI3bDJhYzFuYnUza3F0eWNlZDAydjYifQ.RFbQDC7kOaW0NBLl9zD4FQ';
export const MAP_STYLE_URL = 'mapbox://styles/james-ems/cjsvs7gth4k3s1fpm3y7qzevk';
export const MAP_HEIGHT = '28rem';
export const MAP_WIDTH = '100%';
export const MIN_ZOOM = 7;
export const MAX_ZOOM = 14;
export const DRAG_ROTATE = true;
export const TRACK_DEFAULT_COLOR = [11, 107, 242, 204];
export const ATTRIBUTION_CONTROL = false;
export const TRANSITION_DELAY = 999;
export const TRANSITION_DURATION = 500;
export const PICKING_RADIUS = 15;
export const INITIAL_VIEW_STATE = {
    latitude: 40.6413,
    longitude: -73.7781,
    zoom: 9,
    minZoom: 7,
    maxZoom: 13,
    bearing: 0,
    pitch: 0,
};
export const COLORS = {
    Departure: [234, 112, 46],
    Arrival: [140, 84, 255],
    Infringement: [255, 255, 255],
    Selected: [90, 167, 0],
};
export const CONROLLER_2D_CONFIG = {
    scrollZoom: true,
    dragPan: true,
    dragRotate: false,
    doubleClickZoom: false,
    touchZoom: false,
    touchRotate: false,
    keyboard: false,
};
export const CONROLLER_3D_CONFIG = {
    scrollZoom: true,
    dragPan: true,
    dragRotate: true,
    doubleClickZoom: true,
    touchZoom: true,
    touchRotate: true,
    keyboard: true,
};
//# sourceMappingURL=config.js.map